export default __webpack_public_path__ + "static/media/summaryIcon.0fe6f956.svg";